import { store } from "../store/index";

export const showError = err => {
  let errorTitle = "Something went wrong";
  let errorDesc = "Check your internet connection and try again";

  if(err.response && err.response.status === 401){
    const cfg = err.config || {};
    const sentToken = cfg.headers && (cfg.headers.authorization || cfg.headers.Authorization);
    const url = String(cfg.url || '');
    // A request with no/null token or an `undefined` URL is not a real session
    // expiry (e.g. a boot call fired before a consult/token is ready) — don't
    // tear down a valid session over it.
    if (sentToken && sentToken !== 'null' && !url.includes('undefined')) {
      store.dispatch({
        type: "LOGOUT"
      });
      window.location.replace('/');
    }
    return;
  }

  if (err.response && err.response.data && err.response.data.errorMessage) {
    errorDesc = err.response.data.errorMessage;
  } else if (err && err.data && err.data.errorMessage) {
    errorDesc = err.data.errorMessage;
  }

  store.dispatch({
    type: "SHOW_ERROR",
    payload: {
      errorTitle: errorTitle,
      errorDesc: errorDesc
    }
  });
};
